module.exports = __webpack_public_path__ + "static/media/sponsors-rollup.4aee2410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/sponsors/sponsors-rollup.jpg
// module id = 638
// module chunks = 0